{
  "EN": ["sample statement 1", "sample statement 2", "sample statement 3", "sample statement 4", "sample statement 5"]
}
